import { render, staticRenderFns } from "./FireElectricalCauseCommonParts.vue?vue&type=template&id=13cd6a9f&scoped=true"
import script from "./FireElectricalCauseCommonParts.vue?vue&type=script&lang=ts"
export * from "./FireElectricalCauseCommonParts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cd6a9f",
  null
  
)

export default component.exports